import { FiDollarSign } from "react-icons/fi";
import { FaEuroSign, FaQuestion } from "react-icons/fa";

interface Props {
  currencyId: string;
  currencyName: string;
  sizeRem?: number;
  grayscale?: boolean;
  isUnknown?: boolean;
}

export function CurrencyIcon(props: React.PropsWithChildren<Props>) {
  const url = `url(/assets/currencies/${props.currencyId}.png)`;

  const fiatIconsIds: any = {
    "270": <FiDollarSign size={18} />,
    Euro: <FaEuroSign size={18} />,
  };

  const unknownIcon = <FaQuestion size={18} />;

  return (
    <div
      className="logo-container"
      style={{
        backgroundImage: !Object.keys(fiatIconsIds).includes(props.currencyName)
          ? url
          : undefined,
        height: props.sizeRem ? `${props.sizeRem}rem` : "2rem",
        width: props.sizeRem ? `${props.sizeRem}rem` : "2rem",
        filter: props.grayscale ? "saturate(3) grayscale(60%)" : undefined,
      }}
    >
      {Object.keys(fiatIconsIds).includes(props.currencyName) &&
        fiatIconsIds[props.currencyId]}
      {props.isUnknown && props.isUnknown && unknownIcon}
    </div>
  );
}
